module.exports = __webpack_public_path__ + "img/fi-roundup-800x527.1d5f7db6.jpg";